export const ADDRESSES_HEADER_TITLES = {
	ID: 'ID',
	CITY: 'Місто',
	STREET_TYPE: 'Тип вулиці',
	STREET: 'Вулиця',
	HOUSE: 'Будинок',
	FLAT: 'Квартира',
	CREATED_AT: 'Створено',
};
